import {SORT_DIRECTION_ASC} from '../constants.js';
import {
  closeCreateDialog,
  disableMosaics,
  enableMosaics,
  openCreateDialog,
  reset,
  setGridItemScale,
  setSortDirection,
  setStep,
} from '../actions/wizard.js';
import {createReducer} from '@reduxjs/toolkit';
import {set as setSelections} from '../actions/selections.js';
import {trackEvent} from '../analytics.js';

const defaultState = {
  step: 0,
  createDialogOpen: false,
  mosaics: false,
  sortDirection: SORT_DIRECTION_ASC,
  autoSelectFrameCount: 6,
  gridItemScale: 1,
};

export default createReducer(defaultState, builder => {
  builder.addCase(setStep, (state, {payload}) => {
    state.step = payload;
  });

  builder.addCase(openCreateDialog, state => {
    state.createDialogOpen = true;
  });

  builder.addCase(closeCreateDialog, state => {
    state.createDialogOpen = false;
  });

  builder.addCase(enableMosaics, state => {
    state.mosaics = true;
  });

  builder.addCase(disableMosaics, state => {
    state.mosaics = false;
  });

  builder.addCase(setSortDirection, (state, {payload}) => {
    trackEvent('Updated Sort Direction', {
      direction: payload,
    });
    state.sortDirection = payload;
  });

  builder.addCase(setSelections, (state, {payload}) => {
    state.autoSelectFrameCount = payload.length;
  });

  builder.addCase(setGridItemScale, (state, {payload}) => {
    trackEvent('Updated Grid item scale', {
      scale: payload,
    });
    state.gridItemScale = payload;
  });

  builder.addCase(reset, () => defaultState);
});
